@if (type === 'button') {
  <button
    mat-stroked-button
    class="add-service-code-button"
    [disabled]="disabled"
    (click)="openAddServiceCode()"
  >
    <mat-icon>add</mat-icon>
    <span class="text-xs">{{ label }}</span>
  </button>
} @else {
  <div class="icon-button" matTooltip="{{ label }}">
    <button
      mat-icon-button
      [disabled]="disabled"
      (click)="openAddServiceCode()"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>
}
